<template>
	<section>
		<!-- Componentes externos -->
    <VerReporte/>
    <h3 class="primary--text"><v-icon color="primary">business</v-icon> Lista de unidades</h3>
		<v-card>
			<v-card-text>
			  <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que considere necesarias -->
            <td class="text-xs-center">{{ items.item.nombre_unidad }}</td>
            <td class="text-xs-center">{{ items.item.sigla }}</td>
            <td class="text-xs-center">
         
                <v-btn
                v-if="!items.item.id_padre"
              color="#f3cb19"
                @click.prevent="verReporte(items.item,4)"
                icon
                title="Ver reporte del cronograma de vacaciones"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>
             
            </td>
          </template>
        </crud-table>
			</v-card-text>
		</v-card>
	</section>
</template>

<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue'; // Componente Tabla Dinámica
import crud from '@/common/util/crud-table/mixins/crud-table'; // Funciones y Metodos
import VerReporte from "./dialogs/VerReporte";

export default {
	// Importación de métodos y funciones de un archivo mixin 
	mixins: [crud],
	// Variables iniciales del componente
	data () {
		return {
			url: "unidads",
         graphql: true,
      // Cabecera de la tabla
      headers: [
        { text: "Nombre unidad", value: "nombre_unidad", align: "center" },
        { text: "Sigla", value: "sigla", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" },
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
          id
          nombre_unidad
          id_estado
          sigla
          id_entidad
      `,
      filters: [   
        {
          field: "nombre_unidad",
          label: "Nombres unidad",
          type: "text",
          typeG: "String",
        },
        
        {
          field: "sigla",
          label: "Sigla",
          type: "text",
          typeG: "String",
        },
       
      ],
      initData: [
        {
          state: true,
          param: "id_estado",
          value: 17,
        },
      ],
		}
	},
	// Funcionalidades que se ejecutan al montar el componente
  mounted () {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0] // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push('/403')
    }
    this.onFilter();
    this.$bus.$on('closeDialog', () => {
      this.updateList()
    })
  },
	// Métodos y funciones del componente
	methods: {
   verReporte(item,valor){
      item.reprogramacion=valor //programacion=0,repro=1
      this.$bus.$emit('openDialogVerReporte', item)
    },
	},
	// Definición de componentes importados
	components: {
		CrudTable,
	VerReporte,
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/admin/vacaciones/CronogramaVacaciones.vue